import Vue from 'vue';
import Vuex from 'vuex';

import Authc from './Authc';
import Client from './Client';
import Flash from './Flash';
import Messages from './Messages';
import PleaseWait from './PleaseWait';
import UserModule from './User';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authentication: Authc,
    Client,
    flash: Flash,
    messages: Messages,
    pleasewait: PleaseWait,
    // sessionmanager: SessionManager,
    user: UserModule,
  },
});

export default store;
